const Telegram = () => {
  return (
    <svg
      className='social__svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        className='social__path'
        d='M6.01749 13.7085C6.04254 13.3265 6.06759 12.9571 6.0989 12.5939C6.15526 11.7672 6.21162 10.9406 6.28051 10.114C6.28677 10.0388 6.33687 9.94488 6.39323 9.89478C8.60384 7.90335 13.0814 3.88919 13.1002 3.86414C13.1566 3.80778 13.2192 3.69505 13.1879 3.63243C13.1503 3.56981 12.8497 3.61364 12.6117 3.74515C9.85631 5.4673 7.10088 7.18944 4.35171 8.91159C4.25151 8.97421 4.17636 8.98048 4.06364 8.94916C2.91137 8.58595 1.75909 8.22899 0.606821 7.86578C0.481574 7.8282 0.350064 7.77184 0.237342 7.70296C-0.0569883 7.51509 -0.0820377 7.25207 0.187243 7.02662C0.331277 6.90764 0.494098 6.80744 0.663182 6.73855C1.72778 6.31898 14.3332 1.66106 15 1.50024C15.4947 1.43136 16.0122 1.42182 15.9997 1.94786C15.9934 2.29229 15.912 2.63672 15.8431 2.97488C15.1104 6.4317 13.5699 13.6459 13.5323 13.7962C13.3257 14.554 12.7746 14.7481 12.1358 14.2847C11.472 13.7962 10.8082 13.314 10.1444 12.8256C9.65592 12.4623 9.16119 12.1116 8.67273 11.7422C8.56627 11.6608 8.50364 11.6795 8.41597 11.7672C7.83357 12.3308 7.25117 12.8819 6.66877 13.4455C6.4809 13.6146 6.28051 13.7148 6.01749 13.7085Z'
        fill='white'
        fillOpacity='0.9'
      />
    </svg>
  );
};
export default Telegram;
